import { getAgentsWithCreator } from "web_myplann/Activities/Helpers/getAgentsWithCreator";
import { useActivityParticipantGroups } from "web_myplann/Activities/Hooks/useActivityParticipantGroups";
import { useActivityAgentsQuery } from "web_myplann/Api/Activities/useActivityAgentsQuery";
import { useActivityNotesQuery } from "web_myplann/Api/Activities/useActivityNotesQuery";
import { useActivityParticipantsQuery } from "web_myplann/Api/Activities/useActivityParticipantsQuery";
import { useActivityQuery } from "web_myplann/Api/Activities/useActivityQuery";
import { useAgentQuery } from "web_myplann/Api/Advisor/useAgentQuery";

export const useActivityDetail = (activityId: number | null) => {
	const { data: dataEvent, isLoading: isLoadingEvent } =
		useActivityQuery(activityId);
	const { data: dataAgents, isLoading: isLoadingAgents } =
		useActivityAgentsQuery(activityId);
	const { data: dataNotes, isLoading: isLoadingNotes } =
		useActivityNotesQuery(activityId);
	const { data: dataParticipants, isLoading: isLoadingParticipants } =
		useActivityParticipantsQuery(activityId);

	const { data: contact } = useAgentQuery(dataEvent?.author?.id);

	const agents = getAgentsWithCreator(
		dataAgents?.data ?? [],
		dataEvent?.creator,
	);
	const participantGroups = useActivityParticipantGroups(
		dataParticipants?.data ?? [],
		agents,
	);

	const isLoading =
		isLoadingEvent ||
		isLoadingNotes ||
		isLoadingParticipants ||
		isLoadingAgents;

	return {
		event: dataEvent ?? undefined,
		notes: dataNotes?.data ?? [],
		participantGroups,
		isLoading,
		isNotFound: dataEvent === null,
		contact,
	};
};
